
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class FactIndexRorDialog extends SiteEntityDialog<FactIndexRorRow, any> {
        protected getFormKey() { return FactIndexRorForm.formKey; }
        protected getIdProperty() { return FactIndexRorRow.idProperty; }
        protected getLocalTextPrefix() { return FactIndexRorRow.localTextPrefix; }
        protected getService() { return FactIndexRorService.baseUrl; }
        protected getDeletePermission() { return FactIndexRorRow.deletePermission; }
        protected getInsertPermission() { return FactIndexRorRow.insertPermission; }
        protected getUpdatePermission() { return FactIndexRorRow.updatePermission; }

        protected form = new FactIndexRorForm(this.idPrefix);

    }
}